// Fan out explicitly named events; pageviews remain owned by the existing SDKs.
export function createAnalyticsTracker(win = window, doc = document) {
  const umamiScript = doc.querySelector("script[data-website-id]")
  let queued = []
  const send = (callback) => {
    try {
      Promise.resolve(callback()).catch(() => {})
    } catch {
      // Analytics must never interrupt the application or the other destination.
    }
  }
  umamiScript?.addEventListener("load", () => {
    const pending = queued
    queued = []
    if (win.umami?.track) pending.forEach(([event, data]) => send(() => win.umami.track(event, data)))
  }, {once: true})
  umamiScript?.addEventListener("error", () => { queued = [] }, {once: true})

  return {
    enabled: () => typeof win.jitsu === "function" || Boolean(umamiScript || win.umami?.track),
    track(event, data, umamiData = data) {
      if (typeof win.jitsu === "function") send(() => win.jitsu("track", event, data))
      if (umamiData === null) return
      if (win.umami?.track) send(() => win.umami.track(event, umamiData))
      else if (umamiScript && queued.length < 50) queued.push([event, umamiData])
    },
  }
}
